import {timeToMs} from '../../training/TimeStringConversion';

export function sortCaseInsensitive(a, b) {
    if (a && !b) {
        return 1;
    }
    if (!a && b) {
        return -1;
    }
    if (a && b) {
        return a.toLowerCase().localeCompare(b.toLowerCase());
    }
    return 0;
}

export function sortTimes(a, b, aIdx, bIdx) {
    if (a === '-') {
        return 1;
    }
    if (b === '-') {
        return -1;
    }
    if (sortCaseInsensitive(a, b) === 0) {
        return (aIdx >= bIdx ? 1 : -1);
    }
    return (sortCaseInsensitive(a, b));
}

export function sortPerson(person1, person2) {
    if (person1 && person2) {
        return sortCaseInsensitive(`${person1.lastName} ${person1.firstName}`, `${person2.lastName} ${person2.firstName}`);
    }
    return 0;
}

export function sortDates(a, b) {
    if (!a && !b) {
        return 0;
    }

    if (!a && b) {
        return -1;
    }

    if (a && !b) {
        return 1;
    }

    let date1 = a;
    let date2 = b;

    if (!(a instanceof Date)) {
        date1 = new Date(a);
    }

    if (!(b instanceof Date)) {
        date2 = new Date(b);
    }
    if (date1.getTime() === date2.getTime()) {
        return 0;
    }

    return date1.getTime() > date2.getTime() ? 1 : -1;
}

export function sortTimeStrings(a, b) {
    const convertToNumber = (numberString) => {
        return timeToMs(numberString.replace('+', '').replace('-', '').replace('DNF', '0'));
    };
    if (a && !b) {
        return 1;
    }
    if (!a && b) {
        return -1;
    }
    if (a && b) {
        return convertToNumber(a) > convertToNumber(b) ? 1 : -1;
    }
    return 0;
}
